import { getkwargs } from "../../utilities/functions";
import { fetchApi } from "../fetchApi";

export const onChangeGeneral = async ({
  args = {
    id: [],
    values: {},
    keyChange: [],
    defaulChange: {},
  },
  context,
  company_id,
  model = "crm.lead",
} = {}) => {
  try {
    const { id, values, keyChange, defaulChange } = args;
    const raw = JSON.stringify({
      jsonrpc: "2.0",
      method: "call",
      params: {
        args: [id, values, keyChange, defaulChange],
        model,
        method: "onchange",
        ...getkwargs({ company_id, context, model, view_type: "form" }),
      },
    });

    const requestOptions = {
      method: "POST",
      body: raw,
      redirect: "follow",
    };

    const response = await fetchApi({
      endpoint: `/web/dataset/call_kw/${model}/onchange`,
      requestOptions,
    });
    return JSON.parse(response);
  } catch (error) {
    return error;
  }
};
